var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "17px",
    viewBox: "0 0 22 19",
    width: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 16.36a.84.84 0 110 1.68H1.84a.84.84 0 110-1.68h18.32zm0-7.68a.84.84 0 110 1.68H1.84a.84.84 0 110-1.68h18.32zm0-7.68a.84.84 0 110 1.68H1.84a.84.84 0 110-1.68h18.32z",
    fill: "#2d2d2d",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeDasharray: "0,0",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/HamburgerIcon.6198471e6e206aaef055545356bd604c.svg";
export { ForwardRef as ReactComponent };